export default __webpack_public_path__ + "static/media/TESTYBG.f490048a.jpg";